var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderPdfClosedFist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 22.6H80V9.80005L92.7 22.6Z",
    fill: "#E9AF34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 22.6H80V9.80005L92.7 22.6Z",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.9 55.2C124.2 53.9 121.2 53 117.8 52.4C116.404 50.1731 115.199 47.8313 114.2 45.4C116 42.3 117.2 39.5 117.4 37.3C117.6 35.1 116.5 32.5 113.8 32.2C111.1 31.9 109.6 33.5 109.3 36.2C109 38.9 109.8 41.7 111.1 45.1C109.6 47.4 107.9 49.6 106.2 51.8C103.151 51.7814 100.128 52.3589 97.3 53.5C94.5 54.6 93.1 56.9 94.5 59.1C98.1 65.1 105.4 57 107.6 54.6C110.408 54.5672 113.215 54.7343 116 55.1C117.433 57.3717 119.223 59.3977 121.3 61.1C123.5 62.6 125.7 62.8 127.2 60.5C128.7 58.2 128 56.6 125.9 55.2ZM97 57.9C96.1 55.9 102.2 55 103.3 54.9C102.6 55.6 97.9 59.8 97 57.9ZM113.4 35.1C115.8 35.3 113.4 40.6 112.9 41.7C112.6 40.6 110.9 34.8 113.4 35.1ZM109.9 51.7C110.8 50.6 111.5 49.5 112.3 48.4L114.1 52C112.709 51.7969 111.306 51.6967 109.9 51.7ZM124.8 58.9C123.8 60.3 120.7 56.6 120.1 55.8C119.5 55 125.8 57.3 124.8 58.9Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4 62.0001L100.6 16.6001L146.5 38.0001L125.1 83.9001L109.9 76.8001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 126.7V46H26.6L30.7 53.9H35.9",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 126.7H2.5L13.8 71.7C14.0129 70.3927 14.6822 69.2031 15.6892 68.3426C16.6961 67.4821 17.9755 67.0064 19.3 67H101.5C102.196 67.025 102.878 67.2046 103.497 67.5256C104.115 67.8467 104.655 68.3012 105.076 68.8564C105.497 69.4115 105.789 70.0533 105.932 70.7354C106.074 71.4174 106.064 72.1227 105.9 72.8L94.8 126.7H87.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3 120.7C77.3 120.7 77.5 116.5 80 117.2C82.5 117.9 80.9 128.2 80.2 131.1C79.5 134 76.4 137.8 76.4 137.8V141.1H73.4L71.1 137.8",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9 137.8L67.4 141.1H60.7V137.8C60.7 137.8 51.3 129.3 53.5 125.7C55.7 122.1 58.3 126 58.3 126",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 120.4C65.5 120.4 64.3 114.8 66.8 114.6C69.3 114.4 69.1 120.2 69.1 120.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65 126.1V133.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6 126.1V133.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2 126.1V133.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 125C59.5 125 57.6 117.4 59.9 116.6C62.2 115.8 63.2 120.4 63.2 120.4",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4 120.2C71.4 120.2 71.5 114.9 73.7 115.1C75.9 115.3 75 120.2 75 120.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2 62.4001V14.4001C37.2 13.4719 37.5687 12.5817 38.2251 11.9253C38.8815 11.2689 39.7717 10.9001 40.7 10.9001H80.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 34.2H79.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 42.6001H75.8001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 51H79.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 59.4001H68",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPdfClosedFist);
export default __webpack_public_path__ + "static/media/folder_pdf_closed_fist.df51ea88715149d96b26aeda75d5b915.svg";
export { ForwardRef as ReactComponent };